module.exports = __webpack_public_path__ + "media/images/video_page-5eb2c431a77a02b88f0b2a34a5ce394a.jpeg";